
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.607 6.167A5.998 5.998 0 006.6 12.174a5.998 5.998 0 006.007 6.007 5.999 5.999 0 006.007-6.007 5.996 5.996 0 00-6.007-6.007zm0 9.911a3.913 3.913 0 01-3.904-3.904 3.913 3.913 0 013.904-3.904 3.912 3.912 0 013.904 3.904 3.913 3.913 0 01-3.904 3.904zM18.86 4.521c-.776 0-1.403.627-1.403 1.403s.627 1.403 1.403 1.403a1.399 1.399 0 001.296-1.94 1.401 1.401 0 00-1.296-.866zm5.456 7.653c0-1.617.015-3.218-.076-4.833-.09-1.874-.518-3.538-1.889-4.909C20.977 1.06 19.317.635 17.441.543c-1.615-.09-3.217-.075-4.83-.075-1.618 0-3.22-.015-4.833.076-1.875.09-3.538.518-4.91 1.889C1.495 3.807 1.071 5.467.98 7.341c-.09 1.617-.076 3.22-.076 4.833 0 1.614-.016 3.218.076 4.832.091 1.875.518 3.538 1.888 4.91 1.374 1.373 3.035 1.797 4.91 1.888 1.616.09 3.218.076 4.832.076 1.617 0 3.219.015 4.832-.076 1.875-.091 3.538-.519 4.909-1.888 1.374-1.374 1.798-3.035 1.889-4.91.093-1.614.076-3.215.076-4.832zm-2.577 6.906a3.723 3.723 0 01-.885 1.34c-.378.39-.835.691-1.34.886-1.541.612-5.199.474-6.907.474-1.707 0-5.369.138-6.91-.472a3.722 3.722 0 01-1.34-.884 3.746 3.746 0 01-.884-1.34C2.863 17.538 3 13.88 3 12.173c0-1.707-.137-5.369.473-6.909a3.72 3.72 0 01.884-1.342 3.785 3.785 0 011.34-.884c1.541-.608 5.203-.472 6.91-.472 1.707 0 5.369-.137 6.91.472a3.72 3.72 0 011.34.885c.388.377.69.835.884 1.34.61 1.54.473 5.202.473 6.91 0 1.706.137 5.364-.475 6.905v.001z","fill":"#fff"}})])
          )
        }
      }
    